import { render, staticRenderFns } from "./admin-edit-cities.vue?vue&type=template&id=7f474448"
import script from "./admin-edit-cities.vue?vue&type=script&lang=js"
export * from "./admin-edit-cities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports